module.exports = __webpack_public_path__ + "static/img/6698_phase_function_Paper_PointsHejduk_Prediction.ef15efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6698_phase_function_Paper_PointsHejduk_Prediction.png
// module id = hjBj
// module chunks = 0